import { render, staticRenderFns } from "./SiteAccessTable.vue?vue&type=template&id=e8071990&scoped=true"
import script from "./SiteAccessTable.vue?vue&type=script&lang=js"
export * from "./SiteAccessTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8071990",
  null
  
)

export default component.exports